import * as React from "react";
import { Icon, VStack } from "@chakra-ui/react";
import { IoMail } from "react-icons/io5";
import { Form, TextInput } from "components";
import { utils, hooks, Types } from "./duck";

const PasswordRecovery: React.FC = () => {
  const onSubmit = hooks.useResetPassword();

  return (
    <Form<Types.FormValues>
      width="21.25rem"
      {...utils.getValidation()}
      onSubmit={onSubmit}
    >
      <VStack spacing={6}>
        <TextInput
          name="email"
          placeholder="Email"
          label="Email"
          labelHidden
          inputLeftElementProps={{
            children: <Icon as={IoMail} color="gray.400" w={5} h={5} />
          }}
        />
        <Form.Controls
          submitText="Reset Password"
          w="full"
          submitProps={{ w: "full" }}
        />
      </VStack>
    </Form>
  );
};

export default PasswordRecovery;
